import zod from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { DeviceSimpleFormSchema } from '../../Devices/schemas';

export const SportHallFormSchema = zod.object({
  id: zod.number().optional(),
  deviceIds: zod
    .number({ message: MANDATORY_FIELD })
    .array()
    .nonempty({ message: MANDATORY_FIELD }),
  devices: zod.array(DeviceSimpleFormSchema).optional(),
  name: zod
    .string({ message: MANDATORY_FIELD })
    .nonempty({ message: MANDATORY_FIELD }),
  sportUnityId: zod.number({ message: MANDATORY_FIELD }),
  playbackTime: zod
    .number({ message: MANDATORY_FIELD })
    .min(20, {
      message: 'O tempo de reprodução mínimo deve ser de 20 segundos.',
    })
    .max(40, {
      message: 'O tempo de reprodução máximo deve ser de 40 segundos.',
    }),
  videoAdvertisingImages: zod.array(zod.string({ message: MANDATORY_FIELD })),
});
